/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `pending` - pending
 * * `ready` - ready
 * * `error` - error
 * @export
 */
export const BatchTaskStatusEnum = {
  pending: 'pending',
  ready: 'ready',
  error: 'error',
} as const;
export type BatchTaskStatusEnum = (typeof BatchTaskStatusEnum)[keyof typeof BatchTaskStatusEnum];

export function instanceOfBatchTaskStatusEnum(value: any): boolean {
  for (const key in BatchTaskStatusEnum) {
    if (Object.prototype.hasOwnProperty.call(BatchTaskStatusEnum, key)) {
      if ((BatchTaskStatusEnum as Record<string, BatchTaskStatusEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function BatchTaskStatusEnumFromJSON(json: any): BatchTaskStatusEnum {
  return BatchTaskStatusEnumFromJSONTyped(json, false);
}

export function BatchTaskStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchTaskStatusEnum {
  return json as BatchTaskStatusEnum;
}

export function BatchTaskStatusEnumToJSON(value?: BatchTaskStatusEnum | null): any {
  return value as any;
}
